import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=3afe3c0d&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=js&"
export * from "./MainPage.vue?vue&type=script&lang=js&"
import style1 from "./MainPage.vue?vue&type=style&index=1&id=3afe3c0d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe3c0d",
  null
  
)

export default component.exports